<template>
  <li v-if="node" class="node">

    <a v-if="node.label" :href="'/catalog/' + node.id + '/'" :class="{'selected': sectionId == node.id}">
      <span class="sign" v-if="node.children" @click.prevent="showTree">{{ sign }}</span><span class="label">{{ node.label }}</span>
    </a>

    <ul class="node-tree" v-if="node.children" :class="{'open': isShowTree || !node.label}">
      <node v-for="child in node.children" :node="child" :level="level + 1" :key="child.id"></node>
    </ul>
  </li>
</template>

<script>
import eventBus from "./EventBus.vue";

export default {
  name: "node",
  data: function () {
    return {
      isShowTree: this.node.selected,
      sign: this.node.selected ? '−' : '+',
      currentEvent: false
    }
  },
  props: {
    node: {
      type: Object,
      default: function (){
        return {selected: true}
      }
    },
    level: {
      type: Number,
      default: 1
    }
  },
  computed: {
    sectionId() {
      return this.$store.getters.settings.id;
    },
  },
  methods: {
    showTree: function (){
      if (this.isShowTree){
        this.isShowTree = false;
        this.sign = '+';
        this.currentEvent = false;
      } else {
        this.isShowTree = true;
        this.sign = '−';
        this.currentEvent = true;
        if (this.level == 2)
          eventBus.$emit('updateTree', {sign: this.sign});
      }
    }
  },
  mounted() {
    if (this.level == 2) {
      let vm = this;
      eventBus.$on('updateTree', function (data) {
        if (!vm.currentEvent && data.sign == '−'){
          vm.isShowTree = false;
          vm.sign = '+';
        }

        vm.currentEvent = false;
      });
    }
  },
};
</script>

<style scoped>

</style>